export { AtnFilterSlideout as Component } from './filter-slideout.component'
